import React from 'react';

import { Card } from '@/components/ui/card';

interface Day1StatsOverviewProps {
  totalMatters: number;
  totalCompletedTasks: number;
  totalPendingTasks: number;
  totalUrgentTasks: number;
}

export const Day1StatsOverview: React.FC<Day1StatsOverviewProps> = ({
  totalMatters,
  totalCompletedTasks,
  totalPendingTasks,
  totalUrgentTasks,
}) => {
  return (
    <div className="mt-6 grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card className="p-4">
        <div className="text-2xl font-bold text-gray-900">{totalMatters}</div>
        <div className="text-sm text-gray-500">Active Matters</div>
      </Card>
      <Card className="p-4">
        <div className="text-2xl font-bold text-green-600">
          {totalCompletedTasks}
        </div>
        <div className="text-sm text-gray-500">Completed Tasks</div>
      </Card>
      <Card className="p-4">
        <div className="text-2xl font-bold text-orange-600">
          {totalPendingTasks}
        </div>
        <div className="text-sm text-gray-500">Pending Tasks</div>
      </Card>
      <Card className="p-4">
        <div className="text-2xl font-bold text-red-600">
          {totalUrgentTasks}
        </div>
        <div className="text-sm text-gray-500">Urgent Tasks</div>
      </Card>
    </div>
  );
};
